import { render, staticRenderFns } from "./clinicproductivityreport.vue?vue&type=template&id=528d5e12&scoped=true&"
import script from "./clinicproductivityreport.vue?vue&type=script&lang=js&"
export * from "./clinicproductivityreport.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./clinicproductivityreport.vue?vue&type=style&index=1&id=528d5e12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d5e12",
  null
  
)

export default component.exports